import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui-kit/dropdown-menu';
import { Button } from '@/components/ui-kit/button';
import { EllipsisVertical, Settings, Trash } from 'lucide-react';
import { FolderConfigureModal } from '@/modules/gpt-chats/components/knowledge-base/kb-selected-folder/components/configure-folder-modal';
import { useState } from 'react';
import { FolderDropdownDelete } from './folder-dropdown-delete';
import { IFolder } from '@/modules/gpt-chats/types/kb.service.type';
import { useTranslation } from 'react-i18next';

export const FolderCardDropdown = ({
  folder,
}: {
  folder: IFolder;
}) => {
  const { t } = useTranslation();
  const iconClass = 'mr-2 aspect-square w-4';
  const [isConfigureModalOpen, setIsConfigureModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleConfigure = (e: Event) => {
    e.stopPropagation();
    setIsConfigureModalOpen(true);
  };

  const handleDelete = (e: Event) => {
    e.stopPropagation();
    setIsDeleteModalOpen(true);
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="-mt-1 h-fit w-fit rounded-full p-2"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <EllipsisVertical className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={(e) => handleConfigure(e)}>
            <Settings className={iconClass} />
            {t('CONFIGURE')}
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={(e) => handleDelete(e)}>
            <Trash className={iconClass} />
            {t('DELETE')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <FolderConfigureModal
        folder={folder}
        open={isConfigureModalOpen}
        onOpenChange={setIsConfigureModalOpen}
      />
      <FolderDropdownDelete
        folder_id={folder._id}
        open={isDeleteModalOpen}
        onOpenChange={setIsDeleteModalOpen}
      />
    </>
  );
};
